import './bootstrap';
import { createApp, defineAsyncComponent } from 'vue';
import ConsentBanner from './components/ConsentBanner.vue';
import ConsentWrapper from './components/ConsentWrapper.vue';
import { loadPrimeVue } from '@/utils/loadPrimeVue.js';

// 1. Create Vue app
const app = createApp({});

// 2. Register critical components
app.component('consent-banner', ConsentBanner);
app.component('consent-wrapper', ConsentWrapper);

// 3. Lazy-load non-critical components with optional loading spinner
app.component(
  'gallery-lazy-loader',
  defineAsyncComponent({
    loader: () => import('./components/GalleryLazyLoader.vue'),
    delay: 150,
  })
);

app.component(
  'testimonial-lazy-loader',
  defineAsyncComponent({
    loader: () => import('./components/TestimonialLazyLoader.vue'),
    delay: 150,
  })
);

app.component(
  'quote-form-loader',
  defineAsyncComponent({
    loader: () => import('./components/QuoteForm.vue'),
    delay: 100,
  })
);

// 4. Lazy-load Google Maps during idle time
app.component(
  'google-map-lazy-loader',
  defineAsyncComponent({
    loader: () =>
      new Promise((resolve) => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => resolve(import('./components/GoogleMap.vue')));
        } else {
          setTimeout(() => resolve(import('./components/GoogleMap.vue')), 2000);
        }
      }),
    delay: 100,
  })
);

// 5. Provide dynamic loaders for programmatic use
app.provide('QuoteFormLoader', () => import('./components/QuoteForm.vue'));
app.provide('GoogleMapLazyLoader', () =>
  new Promise((resolve) => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => resolve(import('./components/GoogleMap.vue')));
    } else {
      setTimeout(() => resolve(import('./components/GoogleMap.vue')), 2000);
    }
  })
);

// 6. Load PrimeVue dynamically
await loadPrimeVue(app);

// 7. Mount app
app.mount('#app');
